export const Fetch = Symbol('Fetch')
export const TranslationFetcherSym = Symbol('TranslationFetcher')
export const ContextWrappedFetchSym = Symbol('ContextWrappedFetch')
